import React from 'react'
import { Box, Divider, Typography, useTheme } from '@mui/material'
import { BrowserView, MobileView } from 'react-device-detect'
import { ConnectedDotsIcon } from '../../Icons/ConnectedDotsIcon'
import { CreditCardIcon } from '../../Icons/CreditCardIcon'
import { ApplicationIcon } from '../../Icons/ApplicationIcon'
import { Stack } from '@mui/system'
import {
  AppDownloadButtonEvent,
  CardConfirmationScreenOpened,
  CreditCardReadyProps
} from './types'
import { QrCode } from '../../Icons/QrCode'
import { DownloadAppStoreIcon } from '../../Icons/DownloadAppStoreIcon'
import { IOS_APP_URL } from '../types'
import {
  sendTrackingEvent,
  toButtonEvent,
  toScreenEvent
} from '../../../services/amplitude.service'

export const CreditCardReadyComponent: React.FC<CreditCardReadyProps> = ({
  cardDetails
}) => {
  const theme = useTheme()
  const { address } = cardDetails
  sendTrackingEvent(toScreenEvent({ ...CardConfirmationScreenOpened }))

  return (
    <>
      <Typography component="div" variant="h5" align="center" gutterBottom>
        Your Paceline Card is on its way!
      </Typography>

      <div style={{ textAlign: 'center', marginBottom: 20 }}>
        <ConnectedDotsIcon sx={{ height: '1em', width: '2em' }} />
      </div>

      <div
        style={{
          display: 'flex',
          flexFlow: 'row wrap'
        }}
      >
        <div style={{ flex: 1, textAlign: 'center' }}>
          <CreditCardIcon
            style={{
              height: '7.5em',
              width: '10em',
              borderRadius: 10
            }}
          />
        </div>

        <div style={{ flex: 1, minWidth: 100, marginTop: 10 }}>
          <Stack spacing={1}>
            <Typography variant="body2" component="div">
              Estimated arrival is 7-10 business days. You can access your line
              of credit immediately by downloading Paceline from the Apple App
              Store.
            </Typography>

            <Typography variant="body2" component="div">
              Shipping to:
            </Typography>

            <Box
              sx={{
                p: 1,
                bgcolor: theme.palette.secondary.light,
                borderRadius: 5,
                maxWidth: 350
              }}
            >
              <Typography variant="body2" component="div">
                {address.street} {address.refinement}
              </Typography>
              <Typography variant="body2" component="div">
                {address.city}, {address.state}
              </Typography>
              <Typography variant="body2" component="div">
                {address.country}
              </Typography>
            </Box>
          </Stack>
        </div>
      </div>

      <Divider variant="fullWidth" sx={{ mt: 3, mb: 3 }} />

      <Typography component="div" variant="h6" align="center" gutterBottom>
        Download the Paceline App!
      </Typography>

      <div
        style={{
          display: 'flex',
          flexFlow: 'row wrap',
          columnGap: 20,
          marginTop: 20,
          rowGap: 20
        }}
      >
        <div
          style={{
            display: 'flex',
            flexFlow: 'row nowrap',
            flex: 1,
            columnGap: 10,
            minWidth: 150
          }}
        >
          <div>
            <ApplicationIcon
              sx={{ height: '2em', width: '2em', borderRadius: 2 }}
            />
          </div>

          <Typography component="div" variant="caption">
            You should be rewarded for being healthy. That's why Paceline
            incentivizes you to achieve 150 minutes of elevated heart rate
            activity each week.
          </Typography>
        </div>
        <BrowserView>
          <div
            style={{
              display: 'flex',
              flexFlow: 'row nowrap',
              flex: 1,
              columnGap: 10,
              minWidth: 150
            }}
          >
            <div>
              <QrCode sx={{ height: '2em', width: '2em' }} />
            </div>

            <Typography component="div" variant="caption">
              Scan to download the Paceline app
            </Typography>
          </div>
        </BrowserView>

        <MobileView>
          <div style={{ minWidth: 150 }}>
            <DownloadAppStoreIcon
              sx={{ height: '3.5em', width: '5em' }}
              onClick={() => {
                sendTrackingEvent(
                  toButtonEvent({
                    ...AppDownloadButtonEvent
                  })
                )
                window.open(IOS_APP_URL)
              }}
            />
          </div>
        </MobileView>
      </div>
    </>
  )
}
